/**
 * Exports overlay-related design tokens
 */

export const backgroundColor = 'gray/70';
export const boxShadow = 'out/large';

export const defaultWidth = 44;
export const defaultAlignX = 'center';
export const defaultAlignY = 'center';